import { Injectable } from '@angular/core';
import { IFilterListService } from './ifilter-list.service';
import { map } from 'rxjs';
import { Selectable } from 'src/app/shared/models/types/selectable.type';
import { OrderQueries } from 'src/app/models/shared/enums/get-query';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { WrapperResultGraphQL } from 'src/app/models/shared/types/wrapper-result-graphql.type';
import { PageInfo } from 'src/app/models/shared/types/page-info.type';
import { OrderStatus } from 'src/app/models/common/order-status.models';

@Injectable({
  providedIn: 'root'
})
export class OrderStatusFilterService extends IFilterListService<OrderStatus> {
  pageInfo: PageInfo = { hasPreviusPage: false, hasNextPage: false, startCursor: null, endCursor: null };

  search(searchText: string, variables): void {
    if (searchText) this.pageInfo = { ...this.pageInfo, endCursor: null, startCursor: null };

    this.graphQlService.getData<OrderStatus>(OrderQueries.GET_ORDER_STATUSES_NO_IDS, { search: searchText, companyId: this.appService.companyId, first: variables.first, after: this.pageInfo.endCursor })
      .pipe(
        takeUntilDestroyed(this.destroyRef),
        map(res => res['data']['orderStatuses'])
      )
      .subscribe({
        next: (res: WrapperResultGraphQL<any>) => {
          let datasource: Array<Selectable<OrderStatus>> = [];
          datasource = res.nodes.map(el => ({ statusId: el.id, statusName: el.name, displayId: el.id!, displayName: el.name, disabled: false, selected: false }));
          this.datasource.next(datasource);
        }
      })
  }
}
